export const skillSet = [
  { name: 'Java (Spring)', level: 92 },
  { name: 'Python', level: 90 },
  { name: '.NET (C#/VB.NET)', level: 80 },
  { name: 'AWS', level: 90 },
  { name: 'SQL', level: 86 },
  { name: 'Docker', level: 83 },
  { name: 'Kubernetes', level: 78 },
  { name: 'Kafka', level: 80 },
  { name: 'Terraform (IaC)', level: 74 },
  { name: 'OAuth2 / SAML (ADFS)', level: 74 },
  { name: 'JavaScript', level: 72 },
  { name: 'React', level: 55 },
];
